import { LazyLoadedStates, LazyLoadedStatesManager } from '@edl-development/edl-common';
import { ItemPacketLazyLoadedStates } from './item-packets.lazy-loaded-states';
import { AutoAssignmentLazyLoadedStates } from './auto-assignment.lazy-loaded-states';

export const AdministrationLazyLoadedStates = new LazyLoadedStatesManager<{
    base: LazyLoadedStates,
    settings: LazyLoadedStates,
    emailContent: LazyLoadedStates,
    alert: LazyLoadedStates,
    token_list: LazyLoadedStates,
    token_add: LazyLoadedStates,
    token_edit: LazyLoadedStates,
    edl_template_types: LazyLoadedStates
}> ({
    base: {
        name: 'authenticated.administration',
        url: '/administrationmanagement',
    },
    settings: {
        name: 'authenticated.administration.settings',
        url: '/settings'
    },
    emailContent: {
        name: 'authenticated.administration.emailcontent',
        url: '/email'
    },
    alert: {
        name: 'authenticated.administration.alertcontent',
        url: '/alert'
    },
    token_list: {
        name: 'authenticated.administration.token-list',
        url: '/token-list'
    },
    token_add: {
      name: 'authenticated.administration.token-add',
      url: '/token-create'
    },
    token_edit: {
      name: 'authenticated.administration.token-edit',
      url: '/token-details/:tokenid'
    },
    edl_template_types: {
        name: 'authenticated.administration.edl-template-types',
        url: '/edl-template-types'
    }
},
() => import('src/app/administration/administration.module').then((result: {AdministrationModule: any}) => result.AdministrationModule),
[
    ItemPacketLazyLoadedStates,
    AutoAssignmentLazyLoadedStates
]);